<template>
  <div class="inquiries__guide">
    <h3 class="inquiries__guide-title">ご契約者さまへ</h3>
    <div class="inquiries__guide-body">
      <ul>
        <li><em>故障について</em>のお問い合わせは<a href="https://web113.ntt-east.co.jp/" target="_blank">こちら</a></li>
        <li>解約や料金などの<em>各種お手続き</em>は<a href="https://business.ntt-east.co.jp/support/contact/" target="_blank">こちら</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "InquiriesGuide",
};
</script>

<style lang="scss" scoped>
.inquiries__guide {
  border: 1px solid #D6EDFF;
  border-radius: 8px;
  display: grid;
  grid-template-columns: 120px 1fr;
  margin-bottom: 32px;
  overflow: hidden;
  &-title {
    background: $c-main;
    color: #fff;
    display: grid;
    place-items: center;
    font-size: 1.4rem;
    font-weight: bold;
    text-align: center;
    padding: 10px;
  }
  &-body {
    font-size: 1.4rem;
    padding: 14px 16px;
    em {
      font-style: normal;
      font-weight: bold;
    }
    ul {
      li {
        line-height: 1.75;
        position: relative;
        padding-left: 1.5em;
        &::before {
          content: "";
          position: absolute;
          top: 0.7em;
          left: 5px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #0078e4;
        }
      }
    }
  }
}
</style>
